import { Component } from "@angular/core"
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from "ngx-file-drop"
import { BaseService } from "src/app/services/base.service"
import { HelpersService } from "src/app/services/helpers.service"
import readXlsxFile from "read-excel-file"

@Component({
	selector: "app-modal-upload-file",
	templateUrl: "./modal-upload-file.component.html",
	styleUrls: ["./modal-upload-file.component.scss"]
})
export class ModalUploadFileComponent {
	public files: NgxFileDropEntry[] = []
	public fileReady: boolean = false
	private fileToUpload: any
	public maxRows = 1000
	public isFileSelected: boolean = false
	public uploadError: boolean = false

	constructor(
		private baseService: BaseService,
		private helpersService: HelpersService
	) {}

	public dropped(files: NgxFileDropEntry[]) {
		this.fileReady = false
		this.uploadError = false
		this.isFileSelected = true
		this.files = files
		for (const droppedFile of files) {
			// Is it a file?
			if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry
				fileEntry.file((file: File) => {
					const myFileName = file.name
					// Convert to base64
					const reader = new FileReader()
					reader.readAsDataURL(file)
					reader.onload = () => {
						// this.uploadFile(reader.result);
						readXlsxFile(file).then(rows => {
							let i = 0
							for (const row of rows) {
								if (!this.isNull(row)) {
									i++
								}
							}
							if (i <= this.maxRows) {
								const base64String = reader.result.toString()
								const b64 = base64String.replace(/^data:.+;base64,/, "")
								this.fileReady = true
								this.fileToUpload = { attachment_name: myFileName, attachment: b64 }
							} else {
								this.isFileSelected = false
								this.uploadError = true
								files.pop()
								this.baseService.toastr.error(
									"File must have less than " + this.maxRows + " rows",
									"",
									this.baseService.toastrOptions
								)
							}
						})
					}
				})
			} else {
				this.isFileSelected = false
				files.pop()
				this.baseService.toastr.error("File must be .XLSX", "", this.baseService.toastrOptions)
			}
		}
	}

	public uploadFile() {
		this.baseService.uploadFile(this.fileToUpload).subscribe(res => {
			this.baseService.toastr.success("File uploaded successfully", "", this.baseService.toastrOptions)
			this.files = []
			this.fileToUpload = {}
			this.fileReady = false
			this.isFileSelected = false
			this.helpersService.checkForNotifications().subscribe()
			return
		})
	}

	isFileAllowed(fileName: string) {
		let isFileAllowed = false
		const allowedFiles = [".xls", ".xlsx"]
		const regex = /(?:\.([^.]+))?$/
		const extension = regex.exec(fileName)
		if (undefined !== extension && null !== extension) {
			for (const ext of allowedFiles) {
				if (ext === extension[0]) {
					isFileAllowed = true
				}
			}
		}
		return isFileAllowed
	}

	private isNull(array) {
		for (let i = 0; i < array.length; i++) {
			if (array[i] !== null) return false
			return true
		}
	}
}
